import url from './url';

async function handleRedacao(token, payload) {

    return await fetch(`${url}/redacao/send`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

async function listRedacoes(token) {

    let data = await fetch(`${url}/redacao/list`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleRedacao, listRedacoes }